import React from 'react';
import { useContact } from '../../context/ContactContext';
import SignInScreen from './SignInScreen';

// Step two: shown until a Connect agent has authenticated. Replaces the demo
// seed data that used to render behind a (browser-blocked) login popup.
export default function LoggedOut() {
  const { handleLogin } = useContact();
  return (
    <SignInScreen
      statusText="CONSOLE ONLINE · VOICE PENDING"
      title="Connect your voice line"
      subtitle="Sign in to Amazon Connect to start taking voice and chat contacts."
      step={{
        label: 'STEP 2 OF 2',
        pct: 100,
        body: 'A Connect sign-in window will open. After login this screen switches to your live console automatically.',
      }}
      footNote="Calls are recorded · PII auto-redacted"
    >
      <button className="sg-submit" onClick={handleLogin}>
        <span>Log in to Amazon Connect</span>
      </button>
    </SignInScreen>
  );
}
